module.exports = __webpack_public_path__ + "img/game_logo4.d50bcd39.png";